var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section-professional-cover-photos" }, [
    _c("div", {}, [
      _vm.isVideo(_vm.experience.experience_photos[0].image_sm)
        ? _c(
            "div",
            { staticClass: "embed-responsive embed-responsive-16by9" },
            [
              _c("iframe", {
                staticClass: "embed-responsive-item",
                attrs: {
                  src: _vm.experience.experience_photos[0].image_sm,
                  allowfullscreen: ""
                }
              })
            ]
          )
        : _c("img", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy",
                value: _vm.experience.experience_photos[0].image_xl,
                expression: "experience.experience_photos[0].image_xl"
              }
            ],
            staticClass: "img-fluid rounded-all",
            attrs: { alt: _vm.experience.experience_photos[0].title },
            on: {
              click: function($event) {
                return _vm.$parent.openGallery(0)
              }
            }
          })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "section-view-photos" }, [
      _c(
        "div",
        {
          staticClass:
            "bg-white border border-dark rounded py-2 px-3 text-small m-2",
          on: {
            click: function($event) {
              return _vm.$parent.openGallery(0)
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-th" }),
          _vm._v(
            " " +
              _vm._s(_vm.$t("message.professional.menu.view_photos")) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a20b2032", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a20b2032","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/experience/components/PhotosMobile.vue
// module id = 2097
// module chunks = 0